import { Button, Input, Select, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";

function ControlBox ({vocabularyGroup, stateHandler}) {

  const vocabularyGroupChangeHandler = (value) =>{
    stateHandler("vocabularyGroup", value)
  }
  return (
    <Space wrap style={{justifyContent: "end"}}>
      <Select options={[{label: "그룹:전체", value:"all"},...vocabularyGroup]} defaultValue="all" onChange={(value)=>{vocabularyGroupChangeHandler(value)}} style={{width:"150px", zIndex:99}}/>
      <Button onClick={()=>stateHandler("insertModal",true)}>
        <PlusOutlined />단어장 등록
      </Button>
    </Space>
  )
}

export default ControlBox